<script setup>
import {defineProps, watch, defineEmits, onMounted, ref, nextTick} from 'vue'

const emit = defineEmits([ "value" ]);

const props = defineProps({
  name: String,
  type: String,
  required: Boolean,
  description: String,
  value: String
})

var v = ref(props.value)

</script>

<template>
  <div>
    <div class="param-container">
      <div class="param-header">
        <span class="me-2">{{ props.name }}</span>
        <span v-if="props.type == 'string'" class="badge text-bg-primary">string</span>
        <span v-if="props.type == 'integer'" class="badge text-bg-warning">integer</span>
        <span v-if="props.required" class="ms-2 badge text-bg-danger">required</span>
      </div>
      <p class="param-description">{{ props.description }}</p>
      <input
        v-model="v"
        @input="$emit('value', v)"
        class="param-input"
        type="text"
        :placeholder="'Enter ' + props.name.toLowerCase()"
      />
    </div>
  </div>
</template>

<style scoped>
.param-container {
  padding: 1rem;
  border-radius: 10px;
  border: 1px solid #313946;
  background-color: transparent;
}

.param-header {
  display: flex;
  align-items: center;
  font-weight: normal;
  margin-bottom: 0.5rem;
}

.param-description {
  color: #6d7785;
  margin-bottom: 1rem;
  font-size: 0.9rem;
}

.param-input {
  width: 100%;
  padding: 0.75rem;
  border-radius: 8px;
  border: 1px solid #313946;
  background-color: transparent;
  color: #ffffff;
  font-size: 0.9rem;
  transition: all 0.2s ease;
}

.param-input:focus {
  outline: none;
  border-color: #bf75fe;
  box-shadow: 0 0 0 3px rgba(191, 117, 254, 0.1);
}

.param-input::placeholder {
  color: #6d7785;
}

.badge {
  font-size: 0.7rem;
  padding: 0.25rem 0.5rem;
}

.text-bg-primary {
  background-color: #0d6efd !important;
  color: white !important;
}

.text-bg-warning {
  background-color: #ffc107 !important;
  color: #000 !important;
}

.text-bg-danger {
  background-color: #dc3545 !important;
  color: white !important;
}
</style>
